import { Accessor, LogicX, ZValidate } from "IZOX/STATIC";
import { XInput } from "IZOX/_X";
import _ from "lodash";
// eslint-disable-next-line no-unused-vars
import React, { CSSProperties, useEffect, useState } from "react";

/**
 * @typedef {import("IZOX/_X/XInput").xinputparams} xinputparams
 * @typedef {import("IZOX/_X/XInput").xinputstyleparams} xinputstyleparams
 * @typedef {import("IZOX/STATIC/ZValidate").fvalidate} fvalidate
 * @typedef {import("IZOX/__Typedef/common").lang} lang
 * 
 * @typedef {Object} qftext
 * @property {String} name
 * @property {lang} label
 * @property {any} defaultValue
 * @property {Function} _onChange
 * @property {Function} _onSetDefault
 * @property {any} formValue
 * @property {({doc, field, addOns}) => Boolean} isError
 * @property {fvalidate | fvalidate[]} validators
 * @property {*} addOns
 * 
 * @typedef {qftext & xinputparams & xinputstyleparams} qftextparams
 * 
 * @param {qftextparams} param0
 * @returns 
 */
const QFText = ({
  name = undefined,
  label = undefined,
  _onChange = null,
  _onSetDefault = null,
  defaultValue = undefined,
  formValue = {},
  addOns = undefined,
  updateVia = undefined, 
  updateField = undefined,
  forceUpdateField = undefined,
  performanceBoost = undefined,
  type = "text",
  isError = undefined,
  validators = [],
  fontFamily = "Palanquin",
  ...others
}) => {

  useEffect(() => {
    if(defaultValue) {
      _onSetDefault?.(name, defaultValue);
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);
  
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    let _value = Accessor.Get(formValue, name);
    setValue(_value);
  }, [formValue, name]);

  if(_.isUndefined(name)) return null;

  let { readOnly, min, max } = others;

  let _error = false;
  if(isError){
    _error = _error || isError({doc: formValue, field: value, addOns});
  }
  if(!_.isEmpty(validators)){
    _error = _error || !ZValidate.Check(value, validators);
  }

  return (
    <XInput
      fontFamily={fontFamily}
      value={value}
      isControlled={true}
      onChangeText={(text) => {
        if(readOnly) return;
        if(type === "number"){
          text = Number(text);
          if(isNaN(text)) text = 0;
          if(type === "number"){
            if(min !== undefined && text < min) text = min;
            if(max !== undefined && text > max) text = max;
          }
        }
        _onChange?.(name, text);
      }}
      type={type}
      pL={12}
      {...others}
      error={_error}
      />
  );
};

export default React.memo(QFText, (prevProps, nextProps) => {
  let propIdentical = Accessor.IsIdentical(nextProps, prevProps);
  if(propIdentical){ return true; }
  
  let {updateVia, updateField, forceUpdateField, performanceBoost, name} = nextProps ?? {};
   
  if(updateVia !== "update") return false;

  if(performanceBoost){
    if(name.includes(updateField)){
      return false;
    }

    if(forceUpdateField?.length > 0 && LogicX.includesOneOf(name, forceUpdateField)){
      return false;
    }

    return true;
  }
  return false;
});

